import * as React from 'react'

import { AppContext } from '@/components/base/appcontext'
import { Typography } from '@/components/ui/typography'

const NotFound: React.FC<{
    text?: string
}> = ({ text }) => {
    const appContext = React.useContext(AppContext)
    return (
        <Typography>
            {appContext.geti18n(text || 'base.notFound.text')}
        </Typography>
    )
}

export default NotFound
